module.exports = __webpack_public_path__ + "static/media/camsoda.7b369839.png";